module.exports = __webpack_public_path__ + "img/video_share.16e43f3d.svg";